var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81735 8.88962L8.81742 8.8897L8.82467 8.88244L11.882 5.82516C11.882 5.82515 11.882 5.82513 11.882 5.82511C11.9133 5.7939 11.9556 5.77637 11.9998 5.77637C12.044 5.77637 12.0864 5.79392 12.1176 5.82516C12.1488 5.85641 12.1663 5.89874 12.1663 5.94289C12.1663 5.98706 12.1488 6.02942 12.1176 6.06067C12.1175 6.06069 12.1175 6.06071 12.1175 6.06072L9.06023 9.118L9.0602 9.11803C8.92091 9.25735 8.75554 9.36786 8.57353 9.44326C8.39153 9.51866 8.19646 9.55746 7.99945 9.55746C7.80245 9.55746 7.60737 9.51866 7.42537 9.44326C7.24337 9.36786 7.078 9.25735 6.93871 9.11804C6.93871 9.11804 6.9387 9.11804 6.9387 9.11803L3.88611 6.06478C3.857 6.03358 3.84094 5.99237 3.84131 5.94964C3.84169 5.90594 3.85922 5.86413 3.89012 5.83323C3.92103 5.80233 3.96283 5.7848 4.00653 5.78442C4.04926 5.78405 4.09046 5.80011 4.12166 5.82921L7.1749 8.88244L7.17482 8.88252L7.18222 8.88962C7.40209 9.10065 7.69503 9.21849 7.99978 9.21849C8.30453 9.21849 8.59748 9.10065 8.81735 8.88962Z",
    fill: "black",
    fillOpacity: 0.87,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.4c8049e8d7bd9cd4d300b3f6d157dab9.svg";
export { ForwardRef as ReactComponent };